export const remove = {
  name: "remove" as const,
  svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M7.6 2.5a.9.9 0 0 1 .9-.9h7a.9.9 0 0 1 .9.9v2.6h4.1a.9.9 0 0 1 0 1.8h-17a.9.9 0 0 1 0-1.8h11.1V3.4H9.4v.1a.9.9 0 0 1-1.8 0v-1ZM5 8.1a.9.9 0 0 1 .9.9v11.6h12.2V9a.9.9 0 1 1 1.8 0v12.5a.9.9 0 0 1-.9.9H5a.9.9 0 0 1-.9-.9V9a.9.9 0 0 1 .9-.9Zm4.5 1a.9.9 0 0 1 .9.9v8a.9.9 0 0 1-1.8 0v-8a.9.9 0 0 1 .9-.9Zm5 0a.9.9 0 0 1 .9.9v8a.9.9 0 0 1-1.8 0v-8a.9.9 0 0 1 .9-.9Z" clip-rule="evenodd"/></svg>`,
  keywords: ["remove"],
  category: "action" as const,
};
